import React from "react";
import {IconButton as MuiIconButton} from "@mui/material";

/**
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<React.PropsWithChildren<{
 * readonly color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'paper.secondary' | 'paper.error' | 'red' | 'paper.primary',
 * readonly className?: string,
 * readonly onPressed?: Function,
 * }  & import('@mui/material').IconButtonProps>> & React.RefAttributes<HTMLButtonElement>>}
 */
const IconButton = React.forwardRef(({
                                         className,
                                         onPressed: onClick,
                                         color = 'secondary',
                                         children,
                                         ...props
                                     }, ref) => {

    return (
        <MuiIconButton
            type={"button"}
            ref={ref}
            onClick={onClick}
            color={color}
            className={className}
            {...props}
        >
            {children}
        </MuiIconButton>
    );
});

export default IconButton;
